// eslint-disable-next-line no-shadow
export enum DropdownMode {
  OVERVIEW = "overview",
  MARKET = "market",
  MARKET_DESKTOP = "market-desktop",
  SPORT_DESKTOP = "sport-desktop",
}
